import { BasicComponent, ComponentChildren } from "haxt";

import "./RouterLink.scss";
import { Router } from "./Router";

export class RouterLink extends BasicComponent<
	JSX.HTMLAttributes<HTMLAnchorElement> & {
		[BasicComponent.Children]?: ComponentChildren;
		query?: Record<string, string>;
	}
> {
	protected override willReceiveProps(): void {
		this.update();
	}

	@BasicComponent.bind() protected onClick(e: MouseEvent) {
		let href = this.props.href;
		if (this.props.query && href) {
			const url = new URL(href, window.location.origin);
			for (const [key, value] of Object.entries(this.props.query)) {
				console.log("Setting query param:", key, value);
				url.searchParams.set(key, value);
			}
			href = url.pathname + url.search;
		}

		if (!href || href.startsWith("http://") || href.startsWith("https://") || href.startsWith("mailto:") || href.startsWith("tel:")) {
			return;
		}

		e.preventDefault();
		Router.navigate(href);
	}

	public render() {
		let { href, class: cls, ...attrs } = this.props;

		if (this.props.query && href) {
			const url = new URL(href, window.location.origin);
			for (const [key, value] of Object.entries(this.props.query)) {
				url.searchParams.set(key, value);
			}
			href = url.pathname + url.search;
		}

		return (
			<a {...attrs} class={BasicComponent.mergeClasses(["RouterLink"], cls)} href={href} onClick={this.onClick}>
				{this.children}
			</a>
		);
	}
}
